import { getContrastRatio } from '@/themes/utils/colorUtils';
import { cx } from '@/themes/utils/cssUtils';
import {
  CircularProgress,
  CircularProgressProps,
  useTheme,
} from '@mui/material';

export function MuiCircularProgress({
  className,
  ...props
}: CircularProgressProps) {
  const theme = useTheme();

  const forcedTextColorClass =
    getContrastRatio(theme.palette.primary.main, '#ffffff') > 3
      ? 'text-wx-primary'
      : 'text-wx-neutral-900';

  return (
    <CircularProgress
      data-testid="circular-progress"
      {...props}
      className={cx(forcedTextColorClass, className)}
    />
  );
}
